import { useEffect, useRef, useState } from "react"

function loadJitsiScript(domain) {
  const host = (domain || "8x8.vc").replace(/^https?:\/\//, "")
  const src = `https://${host}/external_api.js`
  if (document.querySelector(`script[src="${src}"]`)) return Promise.resolve()
  return new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error("Jitsi script failed to load"))
    document.body.appendChild(script)
  })
}

export function JitsiEmbed({ domain, roomName, jwt, displayName, onReady, onLeave }) {
  const containerRef = useRef(null)
  const apiRef = useRef(null)
  const [error, setError] = useState("")

  useEffect(() => {
    if (!domain || !roomName) return undefined
    let cancelled = false

    async function mount() {
      try {
        await loadJitsiScript(domain)
        if (cancelled || !containerRef.current) return
        const options = {
          roomName,
          parentNode: containerRef.current,
          width: "100%",
          height: "100%",
          userInfo: { displayName: displayName || "Participant" },
          configOverwrite: {
            prejoinPageEnabled: true,
            startWithAudioMuted: true,
          },
        }
        if (jwt) options.jwt = jwt
        apiRef.current = new window.JitsiMeetExternalAPI(domain.replace(/^https?:\/\//, ""), options)
        apiRef.current.addListener("videoConferenceJoined", () => onReady?.())
        apiRef.current.addListener("readyToClose", () => onLeave?.())
      } catch (e) {
        if (!cancelled) setError(e.message || "Nu s-a putut încărca consultația video")
      }
    }

    mount()
    return () => {
      cancelled = true
      if (apiRef.current) {
        apiRef.current.dispose()
        apiRef.current = null
      }
    }
  }, [domain, roomName, jwt, displayName, onReady, onLeave])

  if (error) {
    return (
      <div className="flex h-full items-center justify-center p-6 text-sm text-destructive">
        {error}
      </div>
    )
  }

  return <div ref={containerRef} className="h-full w-full min-h-[480px]" />
}
